
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({})
export default class BetaOnlyNotice extends Vue {
  @Prop({ default: 'Not available in this version' })
  public title!: string

  @Prop({
    default:
      'This page uses a feature that isn\'t supported in this version. '
      + 'Please use the beta UI for the latest features.',
  })
  public message!: string

  /** Absolute URL into the Foundry 2.0 UI — build it with the `beta` helpers. */
  @Prop({ required: true })
  public url!: string
}
